module.exports = __webpack_public_path__ + "media/wrong.d7704fa4.mp3";